import * as React from 'react';
import { Link } from 'react-router-dom';
import InvestorType from 'src/entities/InvestorType';
import Person from 'src/entities/Person';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import MyAccountHeaderComponent from '../partials/MyAccountHeader.component';
import './InvestorTypes.css';

export interface InvestorTypesComponentProps {
  profileType: string;
  investorType: InvestorType;
  handleSubmit: () => void;
  checkProfile: () => void;
  changeProfile: () => void;
  redirectProfile: () => void;
  errorMessage: {};
  error: boolean;
  success: boolean;
  activeProfile: Person;
}

class InvestorTypesComponent extends React.Component<InvestorTypesComponentProps> {

  public render(): React.ReactNode {

    return (
      <section className="cuenta-inversor-section">
        <div className="container">
          <MyAccountHeaderComponent
            pageTitle="Tipo de inversor"
            breadcrum="Tipo de inversor"
          />
          {this.props.investorType.type === 'Acreditado' ?
            <div className="row investor-type-content">
              <div className="col-sm-12">
                <div className="simple-card padding-40">
                  <section>
                    <Link to="/mi-cuenta/perfil">
                      <span className="close pointer"/>
                    </Link>
                    <div className="gap-50"/>
                    <div className="text-center">
                      <span className="corrected-circle"/>
                      <div className="gap-20"/>
                      <p>
                        <strong>
                          Ya estás acreditado
                        </strong>
                      </p>
                      <p>
                        Si quieres acreditarte con otro perfil haz click&nbsp;
                        <a onClick={() => this.props.changeProfile()}>aquí</a>
                        .
                      </p>
                    </div>
                    <div className="gap-20"/>
                  </section>
                </div>
              </div>
            </div> :
            <div className="row investor-type-content">
              <div className="col-sm-12">
                {!this.props.success ?
                  <div className="simple-card padding-40">
                    <section>
                      <Link to="/mi-cuenta/perfil">
                        <span className="close pointer"/>
                      </Link>
                      <p className="featured c-black-text">
                        <span className="user-circle"/>
                        Acreditate como inversor
                      </p>
                      <div className="gap-50"/>
                      <h4 className="text-center">
                        ¿Qué tipo de inversor eres?
                      </h4>
                      <div className="gap-20"/>
                      {this.props.profileType === 'physical' ?
                        <p>
                          Por defecto un usuario se considera inversor persona física, si quieres invertir a través de
                          una
                          sociedad, puedes crear tu perfil de persona jurídica <Link to="/mi-cuenta/perfil">aquí</Link>.
                          Si ya dispones de un perfil de persona jurídica puedes cambiar tu perfil&nbsp;
                          <a onClick={() => this.props.changeProfile()}>aquí</a>
                          .
                        </p> :
                        <p>
                          Estás actuando con tu perfil de persona jurídica, si quieres acreditarte como persona física,
                          haz <a onClick={() => this.props.changeProfile()}>click aquí para cambiar de perfil</a>.
                        </p>
                      }
                      <p>
                        <strong>
                          La regulación aprobada el 16/04/2015, Ley 05/2015, Ley de Fomento de la Financiación
                          Empresarial,
                          nos exige distinguir entre inversor acreditado y no acreditado.
                        </strong>
                      </p>
                      <div className="gap-20"/>
                      <p>
                        La principal diferencia recae en que el&nbsp;
                        <strong>
                          inversor acreditado podrá invertir sin límites
                        </strong>
                        &nbsp;a través de Plataformas de Financiación Participativa (crowdfunding), mientras que a
                        los&nbsp;
                        <strong>
                          inversores no acreditados se les aplicará los límites de
                        </strong>
                        <ul>
                          <li>
                            <strong>
                              Un máximo de inversión de 3.000€ por operación
                            </strong>
                          </li>
                          <li>
                            <strong>
                              Un máximo de inversión de 10.000€ anuales&nbsp;
                            </strong>
                            en operaciones publicadas en el conjunto de Plataformas de Financiación Participativa.
                          </li>
                        </ul>
                      </p>
                      <div className="gap-20"/>
                      <p className="featured c-primary">
                        Acredítate como inversor para invertir sin límites
                      </p>
                      <p>
                        Este proceso tan sólo te llevará 5 minutos y no volveremos a molestarte hasta dentro de 12
                        meses,
                        por lo que te recomendamos que lo pases ahora y puedas navegar tranquilamente por la plataforma.
                      </p>
                    </section>
                    <div className="gap-20"/>
                    <p>
                      <strong>
                        Para ser inversor acreditado deberás cumplir al menos uno de los siguientes requisitos:
                      </strong>
                    </p>
                    <p>
                      Durante los últimos 12 meses, has percibido unos ingresos anuales superiores a 50.000€
                    </p>
                    <p>
                      O bien, tienes un patrimonio financiero superior a 100.000€
                    </p>
                    <p>
                      <strong>
                        Si cumples estos requisitos, sólo tendrás que completar estos 3 sencillos pasos para
                        acreditarte:
                      </strong>
                    </p>
                    <div className="gap-20"/>
                    <div className="row flex-container">
                      <div className="simple-card col-md-4">
                        <img
                          alt="step 1"
                          src="/img/estructuraci-n.svg"
                          style={{width: '65px', height: '65px'}}
                        />
                        <p>
                          Superar el <strong>Test de Idoneidad</strong> de tal manera que podamos evaluar tu
                          experiencia y conocimientos.
                        </p>
                      </div>
                      <div className="simple-card col-md-4">
                        <img
                          alt="step 2"
                          src="/img/estructuraci-n.svg"
                          style={{width: '65px', height: '65px'}}
                        />
                        <p>
                          <strong>Leer y aceptar</strong> la advertencia de riesgos y no sujeción a supervisión.
                        </p>
                      </div>
                      <div className="simple-card col-md-4">
                        <img
                          alt="step 3"
                          src="/img/estructuraci-n.svg"
                          style={{width: '65px', height: '65px'}}
                        />
                        <p>
                          <strong>Solicitar ser considerado como inversor acreditado</strong>, renunciando de
                          forma
                          expresa a tu tratamiento como inversor no acreditado.
                        </p>
                      </div>
                    </div>
                    <div className="gap-30"/>
                    <p className="text-center">
                      <button
                        className="btn btn-secondary btn-lg"
                        onClick={this.props.checkProfile}
                      >
                        Quiero acreditarme
                      </button>
                    </p>
                    <div className="gap-30"/>
                    {this.props.investorType.type === 'No acreditado' && !this.props.investorType.confirmed ?
                      <p className="text-center">
                        <strong>No cumplo los requisitos de acreditación </strong>
                        <a onClick={this.props.handleSubmit}>No acreditarme</a>
                      </p> : null
                    }
                    <div className="gap-20"/>
                    <ErrorMessagesComponent errorMessage={this.props.errorMessage}/>
                    {this.props.error ?
                      <div className="padding-left-30">
                        <strong>
                          <a
                            onClick={this.props.redirectProfile}
                          >
                            Completar perfil
                          </a>
                        </strong>
                      </div> :
                      null
                    }
                  </div> :
                  <div className="simple-card padding-40">
                    <section>
                      <Link to="/mi-cuenta/perfil">
                        <span className="close pointer"/>
                      </Link>
                      <p className="featured c-black-text">
                        <span className="user-circle"/>
                        Acreditate como inversor
                      </p>
                      <div className="gap-50"/>
                    </section>
                    <div className="row">
                      <div className="text-center col-md-8 col-md-offset-2">
                        <span className="corrected-circle"/>
                        <div className="gap-20"/>
                        <p className="featured c-primary">
                          Muchas gracias por confirmar la solicitud
                        </p>
                        <p>
                          <strong>
                            {this.props.activeProfile.displayName} de acuerdo a la ley 05/2015 no puedes ser inversor
                            acreditado porque no cumples los requisitos
                          </strong>
                        </p>
                        <div className="gap-20"/>
                      </div>
                    </div>
                    <div className="gap-30"/>
                    <p className="text-center">
                      <Link to="/invertir">
                        <button className="btn btn-secondary btn-lg">
                          Ver las oportunidades de inversión
                        </button>
                      </Link>
                    </p>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </section>
    );
  }
}

export default InvestorTypesComponent;



// WEBPACK FOOTER //
// ./src/modules/my-account/investor-types/InvestorTypes.component.tsx